import React from 'react'
import { Link } from 'react-router-dom'
import basicQaidaImg from '../../images/service/service/Basic Qaida.webp'
import tajweedImg from '../../images/service/service/Tajweed.webp'
import tajweedImprovementImg from '../../images/service/service/Tajweed Improvement.webp'
import hifzImg from '../../images/service/service/Hifz.webp'
import classOptionsImg from '../../images/service/service/Class Option.webp'
import freeDemoImg from '../../images/service/service/Free Demo Class.webp'
import assessmentsImg from '../../images/service/service/Assesments subservice.jpg'
import './style.css'

const Service2 = (props) => {

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
      
    const serviceWrap = [
        {
           simg:basicQaidaImg,
           title:"Basic Qaida (Beginner Quran Reading)",
           link:"/basic-qaida"
        },
        {
           simg:tajweedImg,
           title:"Tajweed (Quran Recitation Rules)",
           link:"/tajweed"
        },
        {
           simg:tajweedImprovementImg,
           title:"Tajweed Improvement (Advanced Recitation)",
           link:"/tajweed-improvement"
        },
        {
           simg:hifzImg,
           title:"Hifz (Quran Memorisation)",
           link:"/hifz"
        },
        {
           simg:classOptionsImg,
           title:"Class Options",
           link:"/class-options"
        },
        {
           simg:freeDemoImg,
           title:"Free Demo Class",
           link:"/free-demo"
        },
        {
           simg:assessmentsImg,
           title:"Assessments & Certification",
           link:"/assessments"
        },
    ]

    return(
        <div className={`service-area-2 ${props.serviceClass}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="wpo-section-title">
                            <span>What We Offer</span>
                            <h2>Our Quran Learning Services</h2>
                        </div>
                    </div>
                </div>
                <div className="service-wrap">
                    <div className="row">
                        {serviceWrap.map((item, i) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 custom-grid col-12" key={i}>
                                <div className="service-single-item">
                                    <div className="service-single-img">
                                        <img src={item.simg} alt="" />
                                    </div>
                                    <div className="service-text">
                                        <h2><Link onClick={ClickHandler} to={item.link}>{item.title}</Link></h2>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Service2;